import { createFileRoute } from '@tanstack/react-router'
import { AppUserHelmetShow } from '@/features/app-user-helmets/pages/app-user-helmet-show'

export const Route = createFileRoute('/_authenticated/app-user-helmets/$appUserHelmetId/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { appUserHelmetId } = Route.useParams()
  return <AppUserHelmetShow appUserHelmetId={appUserHelmetId} />
}
